<script>
import { mapGetters } from 'vuex';
import BotForm from './BotForm.vue';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import { useAlert } from 'dashboard/composables';

export default {
  components: {
    BotForm,
    PageHeader,
  },
  computed: {
    ...mapGetters({ uiFlags: 'wgptBots/getUIFlags' }),
    isCreating() {
      return this.uiFlags.isCreating;
    },
  },
  methods: {
    async createBot(data) {
      try {
        const bot = await this.$store.dispatch('wgptBots/create', {
          ...data,
        });

        router.replace({
          name: 'wgpt_bots_add_inboxes',
          params: {
            page: 'new',
            botId: bot.id,
          },
        });
      } catch (error) {
        useAlert(this.$t('WGPT_BOTS.NEW_FLOW.CREATE.FORM.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('WGPT_BOTS.NEW_FLOW.CREATE.TITLE')"
      :header-content="$t('WGPT_BOTS.NEW_FLOW.CREATE.DESC')"
    />
    <div class="flex flex-wrap">
      <BotForm
        :on-submit="createBot"
        :submit-in-progress="isCreating"
        :submit-button-text="$t('WGPT_BOTS.NEW_FLOW.CREATE.FORM.SUBMIT')"
      />
    </div>
  </div>
</template>
